const ROOT = 'UNIT_PAYMENT_DETAILS_TABS_CREDITS_';

const actions = {
  LOAD_CREDITS_REQUEST: `${ROOT}LOAD_CREDITS_REQUEST`,
  LOAD_CREDITS_SUCCESS: `${ROOT}LOAD_CREDITS_SUCCESS`,
  LOAD_CREDITS_ERROR: `${ROOT}LOAD_CREDITS_ERROR`,
} as const;

export default actions;
